import { createContext } from 'react';

export type AlertDialogOptions = {
  title: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  confirmButtonVariant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
  preventOutsideClose?: boolean; // 외부 클릭으로 닫히는 것 방지
};

interface AlertDialogContextType {
  showAlert: (options: AlertDialogOptions) => Promise<boolean>;
}

export const AlertDialogContext = createContext<AlertDialogContextType | undefined>(undefined);
